import React from 'react'

import './LogoStyles.less'

export default () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.99999 0.777771C3.56049 0.777771 0.777771 3.56049 0.777771 6.99999C0.777771 10.4395 3.56049 13.2222 6.99999 13.2222C10.4395 13.2222 13.2222 10.4395 13.2222 6.99999C13.2222 3.56049 10.4395 0.777771 6.99999 0.777771Z"
      fill="#723080"
    />
    <path
      d="M7.88149 7.47535C8.78025 7.25066 9.67038 6.49881 9.67038 5.27165C9.67038 3.76794 8.64198 3.05066 7.00865 3.05066C5.56544 3.05066 4.73581 3.73338 4.54568 4.90868H3.8284L5.25433 6.11856L6.76667 4.90868H5.95433C5.95433 4.90868 5.96297 4.06177 7.02593 4.06177C7.93334 4.06177 8.24445 4.7272 8.24445 5.28029C8.24445 6.08399 7.82099 6.69757 6.80124 6.69757H4.53704V10.6124H5.96297V7.65683H5.97161C6.28272 7.65683 6.59383 7.76918 7.12099 8.5556L8.39136 10.6037H9.98149L8.66791 8.50375C8.32223 7.96794 8.06297 7.61362 7.88149 7.47535Z"
      fill="white"
    />
  </svg>
)
